<template>
    <div class="single-hot-question">
        <TransferIcon
            class="opr-transfer"
            @transfer="tranferItem"
        />
      <DeleteIcon
          class="single-hot-delete"
          @iconClick="deleteHotCard"
      />
       <div class="classify-name">
            <el-input v-model="data.title" @change="titleChange" :placeholder="$t('zhiji.answer.HotCategoryHeading')"></el-input>
        </div>
      <component
          :is="item.wtType"
          v-for="(item, index) in data.items"
          :key="item.uId"
          :count="data.items.length"
          :data="item"
          v-model="data.items[index]"
          @deleteItem="deleteItem"
          @update="updateHandler"
      ></component>
      <div v-show="isShowAdd" class="item-add-btn" @click="addItem">
          <i class="icon-add"></i>
      </div>
    </div>
</template>

<script>
import TransferIcon from "@/views/zhiji/bComponents/icons/TransferIcon.vue"
import HotEditItem from "./HotEditItem.vue";
import DeleteIcon from "@/views/zhiji/bComponents/icons/DeleteIcon";
import { uniqueId, genIndexSearchHandler } from "@/views/zhiji/js/common/util.js";

export default {
    name: "HotQuestCard",
    props: ["data"],
    components: {
        HotEditItem,
        DeleteIcon,
        TransferIcon
    },
    data() {
        return {
            hotQuestionData: this.data
        }
    },
    model: {
        prop: "data",
        event: "update"
    },
    computed: {
        isShowAdd() {
            return this.data.items.length < 4;
        }
    },
    methods: {
        addItem() {
            this.hotQuestionData.items.push({
              uId: uniqueId(),
              hotTitle: '',
              question: '',
              questionId: '',
              wtType: "HotEditItem",
            });
            this.$emit("update", this.hotQuestionData);
        },
        // 删除单个热点问法
        deleteItem(itemId) {
            const itemIdx = genIndexSearchHandler("uId")(this.hotQuestionData.items, itemId.uId);
            this.hotQuestionData.items.splice(itemIdx, 1);
        },
        //删除整个热点问法卡片，透传删除事件
        deleteHotCard() {
            this.$confirm(this.$t("zhiji.answer.delCardTips"),{
                type:'warning'
            }).then(() => {
                this.$emit("deleteCard", this.hotQuestionData);
            });
        },
        tranferItem(event) {
            this.zhiji.dragStart(event, "single-hot-question", "h", newIdx => {
                this.$emit("tranferCard", newIdx, this.data);
            });
        },
        updateHandler() {
            this.$emit("update", this.hotQuestionData);
        },
        titleChange(value) {
            this.hotQuestionData.title = value;
            this.$emit("update", this.hotQuestionData);
        }
    }
};
</script>

<style lang="less" scoped>
.single-hot-question {
    position: relative;
    padding: 14px;
    margin-right: 20px;
    border-radius: 8px;
    background: #f2f7fb;
    .opr-transfer {
        display: none;
        z-index: 1;
        top: -21px;
        left: -2px;
        position: absolute;
    }
    .single-hot-delete {
        display: none;
        z-index: 1;
        right: -9px;
        top: -9px;
        position: absolute;
    }
    &:hover {
      .single-hot-delete {
          display: inline-block;
      }
      .opr-transfer {
          display: inline-flex;
      }
    }
    .classify-name {
        position: relative;
        padding-right: 30px;
        margin-bottom: 12px;
        /deep/.el-input{
            width: 180px;
        }
    }
    .item-add-btn {
        width: 76px;
        height: 32px;
        background: #ffffff;
        border: 1px solid #d8e4f0;
        border-radius: 20px;
        cursor: pointer;
        text-align: center;
        line-height: 30px;
        margin-top: 5px;
        .icon-add {
            display: inline-block;
            width: 14px;
            height: 14px;
            vertical-align: middle;
            background: url("@{zhijiStaticImagePath}class-spr.png");
            background-position: -297px -1px;
        }
    }
}
</style>
